__webpack_require__.p = "https://qa.foodandbev.te2.io/";